export const bankUsage = [
    'BILLS',
    'MOBILE-PAY',
    'SAVINGS-ACCOUNT',
    'HOUSE-LOAN',
    'CAR-LOAN',
    'OTHER-LOANS',
    'CREDIT-CARD',
    'SHARES-AND-FUNDS',
    'ADVISOR',
    'INSURANCE',
    'FAMILY-EXPENSES',
    'FAMILY-ACCOUNT-OVERVIEW',
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYmFua1VzYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvYWNxdWFpbnRhbmNlLWZvcm0vYmFua1VzYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNBLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBZ0I7SUFDbEMsT0FBTztJQUNQLFlBQVk7SUFDWixpQkFBaUI7SUFDakIsWUFBWTtJQUNaLFVBQVU7SUFDVixhQUFhO0lBQ2IsYUFBYTtJQUNiLGtCQUFrQjtJQUNsQixTQUFTO0lBQ1QsV0FBVztJQUNYLGlCQUFpQjtJQUNqQix5QkFBeUI7Q0FDNUIsQ0FBQyJ9